/**
 * Resolves a safe in-app path from a redirectUrl query param.
 * Allows same-origin absolute URLs and relative paths; blocks external redirects.
 * @param {string|null|undefined} redirectUrl - Raw or encoded redirect target.
 * @param {string} [fallback='/'] - Default when redirect is missing or unsafe.
 * @returns {string} Path (+ search + hash) for react-router navigation.
 */
export default function getSafeCdsFpRedirectTarget(redirectUrl, fallback = '/') {
  if (!redirectUrl) return fallback;

  let candidate = redirectUrl;
  try {
    candidate = decodeURIComponent(redirectUrl);
  } catch {
    return fallback;
  }

  if (candidate.startsWith('/') && !candidate.startsWith('//')) {
    return candidate;
  }

  try {
    const parsed = new URL(candidate);
    if (parsed.origin === window.location.origin) {
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    }
  } catch {
    return fallback;
  }

  return fallback;
}
